import { Ocupacion } from './../../../models/tipo/ocupacion.class';
import { ParametrizacionVista } from './../../../models/cliente/validacion-cliente.class';
import { ClienteService } from './../../../services/cliente/cliente.service';
import { Router } from '@angular/router';
import {
  Component,
  ViewChild,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Ciudad } from '../../../models/tipo/ciudad.class';
import { TipoDocumento } from '../../../models/tipo/tipo-documento.class';
import { TipoActividad } from '../../../models/tipo/tipo-actividad.class';
import { DireccionClienteComponent } from './direccion-cliente/direccion-cliente.component';
import { AgenteService } from '../../../services/agente/agente.service';
import { RegistroCliente } from '../../../models/cliente/registro-cliente.class';
import { DireccionCliente } from '../../../models/cliente/direccion-cliente.class';
import { FiltroBuscarCliente } from '../../../models/filtro/filtro-buscar-cliente';
import { DireccionProspecto } from '../../../models/prospecto/direccion-prospecto.class';
import { RegistroProspecto } from '../../../models/prospecto/registro-prospecto.class';
import { DatosPersonalesProspecto } from '../../../models/prospecto/datos-personales-prospecto.class';
import { IdentificacionProspecto } from '../../../models/prospecto/identificacion-prospecto.class';

import { ValidacionCliente } from '../../../models/cliente/validacion-cliente.class';
import { ConstantesFormularioCliente } from './constantes-formulario-clientes';

import { Subscription } from 'rxjs';
import {
  ClienteDireccionService,
  ConsultaEstadoCampoDiferente,
  MensajeInterFormulario,
} from '../../../services/cliente-direccion/cliente-direccion.service';

import * as moment from 'moment';
import { FiltroCliente } from '../../../models/filtro/filtro-cliente';
import { TipoDireccion } from '../../../models/tipo/tipo-direccion.class';

@Component({
  selector: 'app-registro-cliente',
  templateUrl: './registro-cliente.component.html',
  styleUrls: ['./registro-cliente.component.css'],
})
export class RegistroClienteComponent implements OnInit, OnDestroy, OnChanges {
  constantesFormularioCliente: ConstantesFormularioCliente =
    new ConstantesFormularioCliente();

  // Usado por el detector de cambios de prospecto
  camposDiferentes: string[] = [];

  /**
   * Cuantos bloques de dirección se activaron
   */
  direccionesPorInicializar = 0;

  /**
   * La configuración de controles para un producto y tipo de persona
   */
  parametrizacionVista: ParametrizacionVista;

  /**
   * Los campos acá se muestran en el formulario
   */
  listaCamposVisibles: string[] = [];
  /**
   * Los campos acá incluídos son obligatorios en el formulario
   */
  listaCamposObligatorios: string[] = [];

  direccionesInicializadas = 0;
  flipflop = false;

  classColumnsCompartida = {
    'form-group col-md-6': false,
    'form-group col-md-3': true,
  };

  @Input() listCiudades: Ciudad[] = [];
  @Input() listTipoDocumentos: TipoDocumento[] = [];
  @Input() listTipoActividad: Ocupacion[] = [];
  @Input() titulo: String = '';
  @Input()
  soyProspecto = false;
  @Input() validacionProducto: ValidacionCliente;
  @Input() set muestraProspecto(mostrar: boolean) {
    this.cargarStyleColumns(mostrar);
  }
  @Output() cambiosCliente: EventEmitter<any> = new EventEmitter();

  @Input()
  clicKContinuar = false;

  @Input()
  cliente: RegistroCliente;

  clienteDiferencia: any;
  valNumDoc: any;

  @Input()
  formRegistro: FormGroup;

  correoElectronico: String;
  tipoCorreoElectornico: String = '';

  infoDireccionTrabajo: DireccionCliente;
  infoDireccionResidencia: DireccionCliente;
  infoDireccionOtro: DireccionCliente;

  documentoInicial: String = '';

  listaDireccionClienteComponents: DireccionClienteComponent[] = [];

  @ViewChild('direccionTrabajo')
  viewChildDireccionTrabajoComponent: DireccionClienteComponent;
  @ViewChild('direccionResidencia')
  viewChildDireccionResidenciaComponent: DireccionClienteComponent;
  @ViewChild('direccionOtro')
  viewChildDireccionOtroComponent: DireccionClienteComponent;

  direccionTrabajoDiferencia: any;
  direccionResidenciaDiferencia: any;
  direccionOtroDiferencia: any;
  documentosJuridicos = ['A', 'F'];

  listDiferenciasProspecto: String[] = [];

  /**
   * Comunicación entre formularios de componentes x observables
   */
  public subscriptionRevalidarTodosFormularios: Subscription;

  public subscriptionTraspasoInfoDesdeProspectoACliente: Subscription;
  public subscriptionConsultaEstadoCampoDiferente: Subscription;
  public subscriptionTraspasarTodosCamposProspecto: Subscription;

  ejecutarValidador = false;
  ejecutarValidadoresTimer;

  constructor(
    private route: Router,
    private agenteService: AgenteService,
    private cdref: ChangeDetectorRef,
    private clienteDireccionService: ClienteDireccionService
  ) {}

  ngOnDestroy(): void {
    if (!this.soyProspecto) {
      if (
        this.subscriptionRevalidarTodosFormularios &&
        !this.subscriptionRevalidarTodosFormularios.closed
      ) {
        this.subscriptionRevalidarTodosFormularios.unsubscribe();
      }

      // el cliente
      if (
        !this.soyProspecto &&
        this.subscriptionTraspasoInfoDesdeProspectoACliente &&
        !this.subscriptionTraspasoInfoDesdeProspectoACliente.closed
      ) {
        this.subscriptionTraspasoInfoDesdeProspectoACliente.unsubscribe();
      }
    }
    this.ejecutarValidador = false;
  }

  cicloValidacion() {
    this.ejecutarValidadoresTimer = setInterval(() => {
      // Revalidar formularios
      this.clienteDireccionService.setRevalidarTodosFormularios(true);

      // Detección de diferencias
      if (this.soyProspecto) {
        const losControles: string[] = Object.keys(this.formRegistro.controls);

        losControles.forEach((unCtl) => {
          this.clienteDireccionService.setConsultaEstadoCampoDiferente(
            new ConsultaEstadoCampoDiferente(
              unCtl,
              this.formRegistro.get(unCtl).value,
              () => {
                // accionSiIgual
                if (this.camposDiferentes.includes(unCtl)) {
                  this.camposDiferentes = this.camposDiferentes.filter(
                    (unCamp) => unCamp !== unCtl
                  );
                }
              },
              () => {
                // accionSiDiferente
                if (!this.camposDiferentes.includes(unCtl)) {
                  this.camposDiferentes.push(unCtl);
                }
              }
            )
          );
        });
      }

      if (!this.ejecutarValidador) {
        clearInterval(this.ejecutarValidadoresTimer);
      }
    }, 2000);
  }

  ngOnInit(): void {
    this.ejecutarValidador = true;
    this.cicloValidacion();

    this.inicioValoresClientes();
  }
  cargarStyleColumns(mostrar: boolean) {
    this.classColumnsCompartida = {
      'form-group col-md-6': mostrar,
      'form-group col-md-3': !mostrar,
    };
  }

  saveNumDoc($event: any) {
    this.valNumDoc = $event.target.value;
  }

  refrescarClienteXNumeroDocumento($event: any) {
    if (this.valNumDoc === $event.target.value) {
      $event.preventDefault();
      return;
    }

    this.navegarNuevaNTipoNumdocumento();
  }

  refrescarClienteXTipoDocumento($event: any) {
    this.navegarNuevaNTipoNumdocumento();
  }

  navegarNuevaNTipoNumdocumento() {
    this.infoDireccionOtro = null;
    this.infoDireccionTrabajo = null;
    this.infoDireccionResidencia = null;

    this.clienteDireccionService.setLimpiarTodasDirecciones(true);

    setTimeout(() => {
      // Consultar el cliente con el nuevo producto y tipo de identificación y número de identificación
      const filtroCliente = new FiltroCliente(
        this.cliente.tipoIdentificacion,
        this.cliente.numeroIdentificacion
      );
      this.cambiosCliente.emit(filtroCliente);

      setTimeout(() => {
        this.ngOnInit();
      }, 200);
    }, 200);
  }

  inicioValoresClientes() {
    this.correoElectronico = '';
    this.tipoCorreoElectornico = '';
  }

  cargarInformacionFiltro(filtroBuscarCliente: FiltroBuscarCliente) {
    if (!this.cliente) {
      this.cliente = new RegistroCliente();
    }

    this.cliente.tipoIdentificacion =
      filtroBuscarCliente.datosCliente.tipoDocumento;
    this.cliente.numeroIdentificacion =
      filtroBuscarCliente.datosCliente.numeroDocumento;
  }

  getCssDiferencia(campo: string) {
    return { 'input-diferent-select': this.camposDiferentes.includes(campo) };
  }

  getCssDiferenciaTipoCorreo(campo: string) {

    return { 'input-diferent-select': this.camposDiferentes.includes(campo) };
  }

  cargarDireccionXTipo(direccionItem: DireccionCliente, tipoDireccion: String) {
    if (direccionItem.correspondenciaFisica) {
      this.cliente.correspondenciaSeleccionada = tipoDireccion;
    }
    if (direccionItem.correspondenciaElectronica) {
      this.cargarCorreoElectronico(
        tipoDireccion,
        direccionItem.correoElectronico
      );
    }
  }

  cargarCorreoElectronico(tipoDireccion: String, correoElectronico: String) {
    if (
      (tipoDireccion === TipoDireccion.TIPO_DIRECCION_RESIDENCIA.id ||
        tipoDireccion === TipoDireccion.TIPO_DIRECCION_TRABAJO.id ||
        tipoDireccion === TipoDireccion.TIPO_DIRECCION_OFICINA_PRINCIPAL.id ||
        tipoDireccion === TipoDireccion.TIPO_DIRECCION_REP_LEGAL.id) &&
      correoElectronico &&
      correoElectronico !== ''
    ) {
      this.correoElectronico = correoElectronico;
      this.tipoCorreoElectornico = tipoDireccion;

      this.formRegistro.markAsDirty();
    }
  }

  cargarListaDirecciones() {
    this.listaDireccionClienteComponents.push(
      this.viewChildDireccionTrabajoComponent
    );
    this.listaDireccionClienteComponents.push(
      this.viewChildDireccionResidenciaComponent
    );
    this.listaDireccionClienteComponents.push(
      this.viewChildDireccionOtroComponent
    );
  }

  calcularEdad(laFechaDeNacimiento: Date | string): number {
    const hoy = new Date();
    let edad = 0;

    try {
      if (laFechaDeNacimiento) {
        let cumpleanos;

        if (typeof laFechaDeNacimiento === 'string') {
          cumpleanos = new Date(Number(laFechaDeNacimiento));
        } else {
          cumpleanos = new Date(laFechaDeNacimiento);
        }

        edad = hoy.getFullYear() - cumpleanos.getFullYear();
        const m = hoy.getMonth() - cumpleanos.getMonth();

        if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
          edad--;
        }
      } else {
        edad = 0;
      }
    } catch (e) {
      console.error('calcularEdad(' + laFechaDeNacimiento + ')', e);
      edad = 0;
    }

    return Number.isNaN(edad) ? 0 : edad;
  }

  traspasoProspecto(formControl: string) {
    const val = this.formRegistro.get(formControl).value;

    if (val) {
      this.clienteDireccionService.setTraspasoInfoDesdeProspectoACliente(
        new MensajeInterFormulario(formControl, val)
      );
    }
  }

  changeTipoCorreo() {
    this.formRegistro
      .get(this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL)
      .setValidators(Validators.email);
    this.formRegistro
      .get(this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL)
      .updateValueAndValidity();
  }

  obtenerRegistroProspecto() {
    const registroProspecto = new RegistroProspecto();

    registroProspecto.codigoAsesor =
      this.agenteService.getFiltroAgente().codAsesor;
    registroProspecto.dni = this.cliente.tipoIdentificacion.concat(
      this.cliente.numeroIdentificacion.toString()
    );
    registroProspecto.datosPersonales = this.cargarDatosPersonalesProspecto();

    const registroProspectoRetornar: any = {
      codigoAsesor: registroProspecto.codigoAsesor,
      dni: registroProspecto.dni,
    };

    const datosPersonales: any = {};

    if (
      this.listaCamposVisibles.includes(
        this.constantesFormularioCliente.MOSTRAR_CAMPO_NOMBRE_PRIMERO_RS
      )
    ) {
      datosPersonales.primerNombre =
        registroProspecto.datosPersonales.primerNombre;
    }

    if (
      this.listaCamposVisibles.includes(
        this.constantesFormularioCliente.MOSTRAR_CAMPO_NOMBRE_SEGUNDO
      )
    ) {
      datosPersonales.segundoNombre =
        registroProspecto.datosPersonales.segundoNombre;
    }

    if (
      this.listaCamposVisibles.includes(
        this.constantesFormularioCliente.MOSTRAR_CAMPO_APELLIDO_PRIMERO
      )
    ) {
      datosPersonales.primerApellido =
        registroProspecto.datosPersonales.primerApellido;
    }

    if (
      this.listaCamposVisibles.includes(
        this.constantesFormularioCliente.MOSTRAR_CAMPO_APELLIDO_SEGUNDO
      )
    ) {
      datosPersonales.segundoApellido =
        registroProspecto.datosPersonales.segundoApellido;
    }

    if (
      this.listaCamposVisibles.includes(
        this.constantesFormularioCliente.MOSTRAR_CAMPO_FECHA_NACIMIENTO
      )
    ) {
      datosPersonales.fechaNacimiento =
        registroProspecto.datosPersonales.fechaNacimiento;
    }

    if (
      this.listaCamposVisibles.includes(
        this.constantesFormularioCliente.MOSTRAR_CAMPO_SEXO
      )
    ) {
      datosPersonales.sexo = registroProspecto.datosPersonales.sexo;
    }

    if (
      this.listaCamposVisibles.includes(
        this.constantesFormularioCliente.MOSTRAR_CAMPO_CELULAR
      )
    ) {
      datosPersonales.numeroCelular =
        registroProspecto.datosPersonales.numeroCelular;
    }

    if (
      this.listaCamposVisibles.includes(
        this.constantesFormularioCliente.MOSTRAR_BLOQUE_OCUPACION
      )
    ) {
      datosPersonales.ocupacion = registroProspecto.datosPersonales.ocupacion;
    }

    const lasDirecciones: DireccionProspecto[] = [];

    // Opcionalidad del envío del email

    let tipoDireccionAceptable = [];

    if (
      this.hayHijosDeDireccion(
        this.constantesFormularioCliente.MOSTRAR_BLOQUE_DIRECCION_1
      )
    ) {
      tipoDireccionAceptable = [
        TipoDireccion.TIPO_DIRECCION_TRABAJO.id,
        TipoDireccion.TIPO_DIRECCION_OFICINA_PRINCIPAL.id,
      ];

      const laDir = registroProspecto.datosPersonales.direcciones.find(
        (unaDir) => tipoDireccionAceptable.includes(unaDir.tipoDireccion.id)
      );

      if (laDir) {
        if (
          !this.listaCamposVisibles.includes(
            this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL
          )
        ) {
          delete laDir.email;
          delete laDir.esEmailCorrespondencia;
        }

        lasDirecciones.push(laDir);
      }
    }

    if (
      this.hayHijosDeDireccion(
        this.constantesFormularioCliente.MOSTRAR_BLOQUE_DIRECCION_2
      )
    ) {
      tipoDireccionAceptable = [
        TipoDireccion.TIPO_DIRECCION_RESIDENCIA.id,
        TipoDireccion.TIPO_DIRECCION_REP_LEGAL.id,
      ];

      const laDir = registroProspecto.datosPersonales.direcciones.find(
        (unaDir) => tipoDireccionAceptable.includes(unaDir.tipoDireccion.id)
      );

      if (laDir) {
        if (
          !this.listaCamposVisibles.includes(
            this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL
          )
        ) {
          delete laDir.email;
          delete laDir.esEmailCorrespondencia;
        }

        lasDirecciones.push(laDir);
      }
    }

    if (
      this.hayHijosDeDireccion(
        this.constantesFormularioCliente.MOSTRAR_BLOQUE_DIRECCION_3
      )
    ) {
      tipoDireccionAceptable = [
        TipoDireccion.TIPO_DIRECCION_OTRO.id,
        TipoDireccion.TIPO_DIRECCION_SURCURSAL.id,
      ];

      const laDir = registroProspecto.datosPersonales.direcciones.find(
        (unaDir) => tipoDireccionAceptable.includes(unaDir.tipoDireccion.id)
      );

      if (laDir) {
        if (
          !this.listaCamposVisibles.includes(
            this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL
          )
        ) {
          delete laDir.email;
          delete laDir.esEmailCorrespondencia;
        }

        lasDirecciones.push(laDir);
      }
    }

    if (lasDirecciones.length > 0) {
      datosPersonales.direcciones = lasDirecciones;
    }

    if (Object.keys(datosPersonales).length > 0) {
      registroProspectoRetornar.datosPersonales = datosPersonales;
    }

    return registroProspectoRetornar;
  }

  cargarDatosPersonalesProspecto(): DatosPersonalesProspecto {
    return this.isPersonaJuridica()
      ? this.cargarDatosPersonalesProspectoJuridica()
      : this.cargarDatosPersonalesProspectoNatural();
  }

  cargarDatosPersonalesProspectoNatural() {
    const fechaNacimiento = this.obtenerFechaNacimiento();
    const datosPersonales: DatosPersonalesProspecto =
      new DatosPersonalesProspecto();

    datosPersonales.primerNombre =
      this.cliente.nombre1 !== null && this.cliente.nombre1 !== undefined
        ? this.cliente.nombre1.toUpperCase()
        : '';

    // --

    datosPersonales.segundoNombre =
      this.cliente.nombre2 !== null && this.cliente.nombre2 !== undefined
        ? this.cliente.nombre2.toUpperCase()
        : '';

    // --

    datosPersonales.primerApellido =
      this.cliente.apellido1 !== null && this.cliente.apellido1 !== undefined
        ? this.cliente.apellido1.toUpperCase()
        : '';

    // --

    datosPersonales.segundoApellido =
      this.cliente.apellido2 !== null && this.cliente.apellido2 !== undefined
        ? this.cliente.apellido2.toUpperCase()
        : '';

    // --

    datosPersonales.numeroCelular =
      this.cliente.celular !== null &&
      this.cliente.celular !== undefined &&
      this.cliente.celular.replace(/\s/g, '') === ''
        ? null
        : this.cliente.celular;

    // --

    datosPersonales.sexo = this.cliente.sexo;

    // --

    datosPersonales.fechaNacimiento =
      fechaNacimiento !== null
        ? fechaNacimiento instanceof moment
          ? fechaNacimiento.valueOf()
          : fechaNacimiento.getTime()
        : null;
    // --

    datosPersonales.identificacion = this.cargarIdentificacionProspecto();

    // --

    datosPersonales.ocupacion = this.cargarOcupacionSeleccionada(
      this.cliente.ocupacion
    );

    // --

    datosPersonales.direcciones = this.obtenerDireccionesProspecto();

    // --

    // dacordero@personalsoft.com.co - 2021/08/20 - Cambio de Santiago. Copiado y adaptado de feature/TSTAR-2001
    if (this.cliente.paisOrigen) {
      datosPersonales.paisOrigen = this.cliente.paisOrigen;
    }

    // --

    return datosPersonales;
  }

  cargarDatosPersonalesProspectoJuridica() {
    const datosPersonales: DatosPersonalesProspecto =
      new DatosPersonalesProspecto();

    // --
    datosPersonales.primerNombre =
      this.cliente.nombre1 !== null && this.cliente.nombre1 !== undefined
        ? this.cliente.nombre1.toUpperCase()
        : '';

    // --

    datosPersonales.segundoNombre = null;

    // --

    datosPersonales.primerApellido = null;

    // --

    datosPersonales.segundoApellido = null;

    // --

    datosPersonales.numeroCelular =
      this.cliente.celular !== null &&
      this.cliente.celular !== undefined &&
      this.cliente.celular.replace(/\s/g, '') === ''
        ? null
        : this.cliente.celular;

    // --

    datosPersonales.sexo = null;

    // --

    datosPersonales.fechaNacimiento = null;

    // --

    datosPersonales.identificacion = this.cargarIdentificacionProspecto();

    // --

    datosPersonales.ocupacion = null;

    // --

    datosPersonales.direcciones = this.obtenerDireccionesProspecto();

    // --

    // dacordero@personalsoft.com.co - 2021/08/20 - Cambio de Santiago. Copiado y adaptado de feature/TSTAR-2001
    if (this.cliente.paisOrigen) {
      datosPersonales.paisOrigen = this.cliente.paisOrigen;
    }

    // --

    return datosPersonales;
  }

  obtenerFechaNacimiento() {
    let fecha = null;

    if (this.cliente.fechaNacimiento) {
      fecha = moment(this.cliente.fechaNacimiento);
    }

    return fecha;
  }

  // dacordero@personalsoft.com.co - 2021/08/20 - Cambio de Santiago. Copiado y adaptado de feature/TSTAR-2001
  obtenerFechaExpedicion(): Date {
    let fecha = null;
    if (this.cliente.fechaExpedicion) {

      fecha = moment(this.cliente.fechaExpedicion).toDate();
    }

    return fecha;
  }

  cargarOcupacionSeleccionada(idOcupacion: String): Ocupacion {
    let ocupacion: Ocupacion = new Ocupacion();

    if (this.listTipoActividad !== null && this.listTipoActividad.length > 0) {
      ocupacion = this.listTipoActividad.find(function (ocupacionItem) {
        return idOcupacion === ocupacionItem.id;
      });
    }

    return ocupacion;
  }

  cargarIdentificacionProspecto(): IdentificacionProspecto {
    const identificacion: IdentificacionProspecto =
      new IdentificacionProspecto();

    if (
      this.listTipoDocumentos !== null &&
      this.listTipoDocumentos.length > 0
    ) {
      const tipoIdentificacion = this.cliente.tipoIdentificacion;

      const identificacionSelec = this.listTipoDocumentos.find(function (
        identificacionItem
      ) {
        return tipoIdentificacion === identificacionItem.id;
      });
      identificacion.numero = this.cliente.numeroIdentificacion + '';
      identificacion.tipo = identificacionSelec;


      // dacordero@personalsoft.com.co - 2021/08/20 - Cambio de Santiago. Copiado y adaptado de feature/TSTAR-2001
      const fechaExpedicion = this.obtenerFechaExpedicion();

      if (fechaExpedicion) {
       identificacion.fechaExpedicion = fechaExpedicion.getTime();
      }
    }

    return identificacion;
  }

  obtenerDireccionesCliente(): DireccionCliente[] {
    const direcciones: DireccionCliente[] = [];

    this.listaDireccionClienteComponents.forEach((direccionItem) => {
      const direccion = direccionItem.getDireccionCliente(
        this.correoElectronico,
        this.tipoCorreoElectornico
      );
      if (direccion !== null) {
        direcciones.push(direccion);
      }
    });

    return direcciones;
  }

  obtenerDireccionesProspecto(): DireccionProspecto[] {
    const direcciones: DireccionProspecto[] = [];

    this.listaDireccionClienteComponents.forEach((direccionItem) => {
      const direccion = direccionItem.getDireccionProspecto(
        this.correoElectronico,
        this.tipoCorreoElectornico
      );
      if (direccion !== null) {
        direcciones.push(direccion);
      }
    });
    return direcciones;
  }

  changeTipoDocumento(documento?: TipoDocumento) {
    if (documento !== null) {
      this.cliente.tipoPersona = documento.tipoPersona;
    } else {
      this.cliente.tipoPersona = null;
    }
  }

  changeTipoActividad(tipoActividad?: TipoActividad) {
    if (tipoActividad !== null) {
      this.cliente.descripcionOcupacion = tipoActividad.descripcion;
    } else {
      this.cliente.descripcionOcupacion = null;
    }
  }

  checkDocumentoJuridico() {
    if (
      this.cliente &&
      this.cliente.tipoIdentificacion &&
      !this.cliente.tipoPersona
    ) {
      const value =
        this.documentosJuridicos.filter(
          (x) => x === this.cliente.tipoIdentificacion
        ).length > 0;
      this.cliente.tipoPersona = value
        ? ClienteService.TIPO_DOCUMENTO_JURIDICO
        : ClienteService.TIPO_DOCUMENTO_NATURAL;
    }
  }

  isPersonaJuridica() {
    this.checkDocumentoJuridico();
    return (
      this.cliente &&
      this.cliente.tipoIdentificacion &&
      this.cliente.tipoPersona.toUpperCase() ===
        ClienteService.TIPO_DOCUMENTO_JURIDICO
    );
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.validacionProducto && changes.validacionProducto.currentValue) {
      if (!this.validacionProducto.asignacionCampos) {
        console.error(
          'Los campos del producto ' +
            this.validacionProducto.codigoProducto +
            ' no están parametrizados.'
        );
        this.route.navigate(['Inicio']);

        return;
      }

      if (
        this.validacionProducto.asignacionCampos.length < 1
      ) {
        return;
      }


      // Limpiar campos obligatorios y visibles
      this.listaCamposVisibles = [];
      this.listaCamposObligatorios = [];

      const listaParametrizVistaPojo: ParametrizacionVista[] =
        this.validacionProducto.asignacionCampos;

      this.parametrizacionVista = listaParametrizVistaPojo.find((unaParam) => {
        const tipoPers = this.isPersonaJuridica()
          ? ClienteService.TIPO_DOCUMENTO_JURIDICO
          : ClienteService.TIPO_DOCUMENTO_NATURAL;

        return unaParam.tipoTomador === tipoPers;
      });

      // --

      console.warn(
        'Tipo vista seleccionada: ',
        this.parametrizacionVista.tipoTomador
      );

      this.parametrizacionVista.camposObligatorios.forEach((unCampoObli) => {
        if (!this.listaCamposObligatorios.includes(unCampoObli)) {
          // asociado al campo de email va el de MOSTRAR_CAMPO_EMAIL_TIPO
          if (
            unCampoObli === this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL
          ) {
            if (
              !this.listaCamposObligatorios.includes(
                this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL_TIPO
              )
            ) {
              this.listaCamposObligatorios.push(
                this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL_TIPO
              );
            }
            this.addCamposVisibles(
              this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL_TIPO
            );
          }
          if(!(unCampoObli.startsWith(ConstantesFormularioCliente.DIRECCIONES_PREFIJO))  &&
           !unCampoObli.startsWith(ConstantesFormularioCliente.DIRECCION_NECESARIA)){
            this.listaCamposObligatorios.push(unCampoObli);
          }

        }

        this.addCamposVisibles(unCampoObli);
      });

      this.parametrizacionVista.camposOpcionales.forEach((unCampoVis) => {
        // asociado al campo de email va el de MOSTRAR_CAMPO_EMAIL_TIPO
        if (
          unCampoVis === this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL
        ) {
          this.addCamposVisibles(
            this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL_TIPO
          );
        }

        this.addCamposVisibles(unCampoVis);
      });

      // --

      // Limpiar controles no visibles del formulario (cuando recarga un tipo de documento diferente)
      const losCtls = Object.keys(this.formRegistro.controls);
      if (losCtls.length > 0) {
        losCtls.forEach((element) => {
          if (!this.listaCamposVisibles.includes(element)) {
            this.formRegistro.removeControl(element);
          }
        });
      }

      this.listaCamposVisibles.forEach((nombreUnCampoVisible) => {
        if (
          !nombreUnCampoVisible.startsWith(
            ConstantesFormularioCliente.DIRECCIONES_PREFIJO
          )
        ) {
          this.agregarReemplazarFormControl(nombreUnCampoVisible);
        }
      });

      this.suscribirSuscripciones();
    }

    if (changes.cliente && changes.cliente.currentValue) {
      if (!this.cliente) {
        return;
      }

      this.suscribirSuscripciones();

      // Restaurar las direcciones
      this.infoDireccionOtro = null;
      this.infoDireccionTrabajo = null;
      this.infoDireccionResidencia = null;

      try {
        if (this.cliente.direcciones) {
          Object.keys(this.cliente.direcciones).forEach((element) => {
            switch (element) {
              case TipoDireccion.TIPO_DIRECCION_TRABAJO.id:
              case TipoDireccion.TIPO_DIRECCION_OFICINA_PRINCIPAL.id:
                this.infoDireccionTrabajo = this.cliente.direcciones[element];
                break;

              case TipoDireccion.TIPO_DIRECCION_RESIDENCIA.id:
              case TipoDireccion.TIPO_DIRECCION_REP_LEGAL.id:
                this.infoDireccionResidencia =
                  this.cliente.direcciones[element];
                break;

              case TipoDireccion.TIPO_DIRECCION_OTRO.id:
              case TipoDireccion.TIPO_DIRECCION_SURCURSAL.id:
                this.infoDireccionOtro = this.cliente.direcciones[element];
                break;
            }

            this.cargarDireccionXTipo(
              this.cliente.direcciones[element],
              element
            );
          });
        }
      } catch (e) {
        console.error('ERROR:', e);
      }

      this.documentoInicial = this.cliente.numeroIdentificacion;

      if (this.soyProspecto) {
        this.cdref.detectChanges();
      } else {
      }
    }
  }

  addCamposVisibles(unCampo: string): void {
    if (
      unCampo.startsWith(ConstantesFormularioCliente.DIRECCIONES_PREFIJO) &&
      unCampo.length <
        ConstantesFormularioCliente.DIRECCIONES_PREFIJO.length +
          ConstantesFormularioCliente.MAX_SUFIJO_CARACTERES
    ) {
      this.direccionesPorInicializar++;
    }

    if (!this.listaCamposVisibles.includes(unCampo)) {
      this.listaCamposVisibles.push(unCampo);
    }
  }

  direccionLista(cualDireccion: string): void {
    this.direccionesInicializadas++;

    if (this.direccionesPorInicializar === this.direccionesInicializadas) {
      setTimeout(() => {
        this.cargarListaDirecciones();
      }, 1300);
    }
  }

  agregarReemplazarFormControl(nombreUnCampo: string) {
    const esObligatorio = this.listaCamposObligatorios.includes(nombreUnCampo);

    const valorInicial = {
      disabled: this.soyProspecto,
    };

    if (this.formRegistro.contains(nombreUnCampo)) {
      valorInicial['value'] = this.formRegistro.get(nombreUnCampo).value;

      this.formRegistro.setControl(
        nombreUnCampo,
        new FormControl(
          valorInicial,
          esObligatorio ? [Validators.required] : null
        )
      );
    } else {
      valorInicial['value'] = '';
      this.formRegistro.addControl(
        nombreUnCampo,
        new FormControl(
          valorInicial,
          esObligatorio ? [Validators.required] : null
        )
      );
    }
  }

  contieneAlgunaDireccion(): boolean {
    return (
      this.listaCamposVisibles.filter((unCampo) =>
        unCampo.startsWith(ConstantesFormularioCliente.DIRECCIONES_PREFIJO)
      ).length > 0
    );
  }

  getErrors(errObj: any): string {
    const ret = [];

    if (errObj.required) {
      ret.push('required: ' + errObj.required);
    }

    return ret.join(' | ');
  }

  hayAlgo(algo): boolean {
    const a = this.formRegistro.get(algo);

    if (a) {
      return true;
    }
    return false;
  }

  camposVisiblesHayAlgo() {
    return this.listaCamposVisibles.filter((unCampo) => this.hayAlgo(unCampo));
  }

  hayHijosDeDireccion(nombreBloque_x: string): boolean {
    const hallado = this.listaCamposVisibles.find((unCamp) => {
      return unCamp.startsWith(nombreBloque_x);
    });

    if (hallado) {
      return true;
    } else {
      return false;
    }
  }

  analizarFormChange() {
    let err = false;

    this.formRegistro.updateValueAndValidity();

    const controlesDeFormulario: any = this.formRegistro.controls;
    const nombresControles = Object.keys(controlesDeFormulario);

    const busqueda = nombresControles.find((unNombreControl) => {
      let ctlHallado = false;

      const constControlForm = this.formRegistro.get(unNombreControl);
      if (!constControlForm) {
        console.error(
          'El control no existe en el formulario: ',
          constControlForm
        );
      } else {
        ctlHallado = true;
      }

      return (
        controlesDeFormulario[unNombreControl].valid === false &&
        this.listaCamposVisibles.includes(unNombreControl) &&
        ctlHallado
      );
    });

    if (busqueda) {
      const ctl = this.formRegistro.get(busqueda);
      const val = ctl.value;

      if (!val) {
        console.error(
          'analizarFormChange | prospecto: ' +
            this.soyProspecto +
            ' | control con error:' +
            busqueda +
            ' | valor: ' +
            val
        );
      }
    }

    err = busqueda ? true : false;

    // Reportar el estado de validación del form
    this.reportarEstadoForm(err);

    if (!this.flipflop) {
      setTimeout(() => {
        this.flipflop = true;
        this.analizarFormChange();
      }, 500);
    } else {
      this.flipflop = false;
    }
  }

  clienteFormChange($event: any) {

    this.analizarFormChange();
  }

  suscribirSuscripciones() {
    if (!this.soyProspecto) {
      // Cliente

      if (
        !this.subscriptionRevalidarTodosFormularios ||
        this.subscriptionRevalidarTodosFormularios.closed
      ) {
        this.subscriptionRevalidarTodosFormularios =
          this.clienteDireccionService
            .getRevalidarTodosFormularios()
            .subscribe(() => {
              setTimeout(() => {
                this.analizarFormChange();
              }, 500 * Math.random());
            });
      }

      // --

      if (
        !this.subscriptionTraspasoInfoDesdeProspectoACliente ||
        this.subscriptionTraspasoInfoDesdeProspectoACliente.closed
      ) {
        this.subscriptionTraspasoInfoDesdeProspectoACliente =
          this.clienteDireccionService
            .getTraspasoInfoDesdeProspectoACliente()
            .subscribe((mensajeInterForm: MensajeInterFormulario) => {
              const campo = this.formRegistro.get(mensajeInterForm.nombreCampo);

              if (campo) {
                campo.setValue(mensajeInterForm.valor);
              }

            });
      }

      // --

      if (
        !this.subscriptionConsultaEstadoCampoDiferente ||
        this.subscriptionConsultaEstadoCampoDiferente.closed
      ) {
        this.subscriptionConsultaEstadoCampoDiferente =
          this.clienteDireccionService
            .getConsultaEstadoCampoDiferente()
            .subscribe((mensajeComprobacion) => {

              const campoCliente = this.formRegistro.get(
                mensajeComprobacion.nombreCampo
              );

              if (campoCliente) {
                let iguales = false;

                // Comparar ciudad
                if (
                  mensajeComprobacion.nombreCampo.endsWith(
                    this.constantesFormularioCliente
                      .MOSTRAR_CAMPO_FECHA_NACIMIENTO
                  )
                ) {

                  const a = moment(campoCliente.value).diff(
                    mensajeComprobacion.valorActual,
                    'days'
                  );

                  iguales = a < 1;
                } else {

                  iguales =
                    mensajeComprobacion.valorActual === campoCliente.value;
                }

                if (iguales) {
                  if (mensajeComprobacion.accionSiIgual) {
                    mensajeComprobacion.accionSiIgual();
                  }
                } else {
                  if (mensajeComprobacion.accionSiDiferente) {
                    mensajeComprobacion.accionSiDiferente();
                  }
                }
              }

            });
      }
    } else {
      // Prospecto

      // ---

      if (
        !this.subscriptionTraspasarTodosCamposProspecto ||
        this.subscriptionTraspasarTodosCamposProspecto.closed
      ) {
        this.subscriptionTraspasarTodosCamposProspecto =
          this.clienteDireccionService
            .getTraspasarTodosCamposProspecto()
            .subscribe(() => {
              Object.keys(this.formRegistro.controls).forEach(
                (unNombreCampo) => {
                  setTimeout(() => {
                    this.traspasoProspecto(unNombreCampo);
                  }, 200 * Math.random() + 50);
                }
              );
            });
      }
    }
  }

  /**
   * Enviar reporte de errores...
   */

  reportarEstadoForm(hayError: boolean) {

    if (this.soyProspecto) {
      this.clienteDireccionService.setReporteErroresProspecto(hayError);
    } else {
      // cliente
      this.clienteDireccionService.setReporteErroresCliente(hayError);
    }
  }

  lasPropiedades(cliente) {
    const ret = [];

    Object.keys(cliente).forEach((unaClave) => {
      ret.push({ clave: unaClave, valor: cliente[unaClave] });
    });

    return ret;
  }

  estaVacio(any) {
    if (this.soyProspecto) {
      return any ? true : false;
    }
    return false;
  }

  // --

  // Para guardar prospecto
  prepararObjetoParaEnviar2(tt: any) {
    if (
      this.listaCamposVisibles.includes(
        this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL
      ) &&
      !this.contieneAlgunaDireccion()
    ) {

      if (!tt.direcciones) {
        tt.direcciones = [];
      }

      if (tt.direcciones.length < 1) {
        const aDir: any = {};
        aDir.email = this.correoElectronico;

        const tipDir = TipoDireccion.getLista().find(
          (unaDir) => unaDir.id === this.tipoCorreoElectornico
        );

        aDir.tipoDireccion = tipDir;
        aDir.esCorrespondencia = ConstantesFormularioCliente.LITERAL_NO;
        aDir.esEmailCorrespondencia = ConstantesFormularioCliente.LITERAL_SI;

        tt.direcciones.push(aDir as DireccionProspecto);
      }

    }

    // dacordero@personalsoft.com.co - 2021/08/20 - Cambio de Santiago. Copiado y adaptado de feature/TSTAR-2001
    if (this.cliente.paisOrigen) {
      tt.paisOrigen = this.cliente.paisOrigen;
    }

    return tt;
  }

  // Para guardar cliente
  prepararObjetoParaEnviar(tt: any) {
    if (
      this.listaCamposVisibles.includes(
        this.constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL
      ) &&
      !this.contieneAlgunaDireccion()
    ) {
      if (!tt.datosPersonales.direcciones) {
        tt.datosPersonales.direcciones = [];
      }

      // Si no hay direcciones y si viene el campo de email entonces agregar una dirección
      // con la preferencia de constantesFormularioCliente.MOSTRAR_CAMPO_EMAIL_TIPO asociando la dirección

      if (tt.datosPersonales.direcciones.length < 1) {
        const aDir: any = {};
        aDir.email = this.correoElectronico;

        const cuak = TipoDireccion.getLista().find(
          (unaDir) => unaDir.id === this.tipoCorreoElectornico
        );

        aDir.tipoDireccion = cuak.id;
        aDir.correspondenciaFisica = false;
        aDir.correspondenciaElectronica = true;

        tt.datosPersonales.direcciones.push(aDir as DireccionProspecto);
      }

      tt.datosPersonales.email = this.correoElectronico;
    }

    return tt;
  }

  constantesTipoDireccion(campo) {
    return TipoDireccion[campo];
  }

  validarDireccionNecesaria() {
    let esValida = true;

    if (this.listaDireccionClienteComponents !== null && this.listaDireccionClienteComponents !== undefined && this.parametrizacionVista.camposObligatorios.includes('direccionNecesaria')) {
      esValida = false;

        if (this.validarDireccionCorrespondenciaSeleccionada()) {
          esValida = true;
        }

    }
    return esValida;
  }

  validarDireccionCorrespondenciaSeleccionada() {
    return (this.cliente.correspondenciaSeleccionada !== '' &&
      this.cliente.correspondenciaSeleccionada !== null && this.cliente.correspondenciaSeleccionada !== undefined);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cliente/registro-cliente/registro-cliente.component.ts